import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { recoveryPassword } from '../../api/autenticacao';
import Strip from '../Utils/strip';
import { limparDocumento, validaDocumentoPorTipo } from '../Utils/documentoAlfanumerico';
import { aplicaCoresOneShell, getConfigAmbiente } from '../../services/authentication/auth';

const useForgotPasswordHook = () => {
  aplicaCoresOneShell();
  const navigate = useNavigate();
  const [isPending, setPending] = useState(false);
  const [forgotPassword, setForgotPassword] = useState({});
  const [isRecoveredPassword, setRecoveredPassword] = useState(false);
  const [message, setMessage] = useState(false);
  const [loginPending, setLoginPending] = useState(false);
  const configAmbiente = getConfigAmbiente();
  const imgLogoLogin =
    configAmbiente && configAmbiente.imagens && configAmbiente.imagens.LOGO
      ? configAmbiente.imagens.LOGO
      : '';
  const imgBackground =
    configAmbiente && configAmbiente.imagens && configAmbiente.imagens.LOGIN_BACKGROUND
      ? configAmbiente.imagens.LOGIN_BACKGROUND
      : '';
  const tipoAmbiente = window.location.protocol === 'https:' ? 'PRODUÇÃO' : 'TESTE';

  const handleFormSubmit = (values, form) => {
    setLoginPending(true);
    setPending(true);
    const entity = {
      login: values.email,
      documento: Strip(values.documento)
    };

    recoveryPassword(entity)
      .then(() => {
        setForgotPassword(entity);
        form.resetForm();
        setRecoveredPassword(true);
      })
      .catch(error => {
        setMessage('Verifique os dados e tente novamente');
      })
      .finally(() => {
        setPending(false);
        setLoginPending(false);
        form.setSubmitting(false);
      });
  };

  const validateInputs = useCallback(values => {
    const errors = {};

    if (!values.email || !values.email.trim()) {
      errors.email = 'Informe seu login';
    }

    values.documento = values.documento ? values.documento.slice(0, 14) : '';
    const documento = values.documento.trim();

    if (!documento) {
      errors.documento = 'Informe o CPF';
    } else {
      const documentoNormalizado = limparDocumento(documento);
      if (!validaDocumentoPorTipo(documentoNormalizado, 'PF')) {
        errors.documento = 'CPF inválido';
      }
    }

    return errors;
  }, []);

  const limpaMsgErro = () => {
    setMessage(false);
  };

  const acessaLogin = () => {
    navigate('/login');
  };

  return {
    handleFormSubmit,
    validateInputs,
    limpaMsgErro,
    acessaLogin,
    isRecoveredPassword,
    forgotPassword,
    isPending,
    message,
    imgBackground,
    imgLogoLogin,
    tipoAmbiente,
    loginPending
  };
};

export default useForgotPasswordHook;
